export interface CatalogSearch {
  q?: string;
  limit?: number;
}

export const CATALOG_VIEW_ID = 'gear-product-catalog';
export const DEFAULT_CATALOG_LIMIT = 10;
export const MAX_CATALOG_LIMIT = 100;
export const MAX_CATALOG_QUERY_LENGTH = 200;

/** Preserve invalid URL values as a validation state without broadening the query. */
export function parseCatalogSearch(search: Record<string, unknown>): CatalogSearch {
  return {
    q: search.q === undefined ? undefined : typeof search.q === 'string' ? search.q : '\u0000',
    limit:
      search.limit === undefined
        ? undefined
        : typeof search.limit === 'number'
          ? search.limit
          : Number.NaN,
  };
}

export function isCatalogQueryValid(query: CatalogSearch): boolean {
  const q = (query.q ?? '').trim();
  const limit = query.limit ?? DEFAULT_CATALOG_LIMIT;
  return (
    q.length <= MAX_CATALOG_QUERY_LENGTH &&
    !q.includes('\u0000') &&
    Number.isInteger(limit) &&
    limit >= 1 &&
    limit <= MAX_CATALOG_LIMIT
  );
}
